import styled from 'styled-components';
import { colorUsage, fontWeight } from 'stylesheet';
import { Save } from 'theme/icons';
var SaveIcon = styled(Save).withConfig({
  displayName: "SaveButtonstyle__SaveIcon",
  componentId: "sc-7zc33b-0"
})(["& path{fill:", ";}"], colorUsage.iconForeground);
var LastSaveSince = styled.span.withConfig({
  displayName: "SaveButtonstyle__LastSaveSince",
  componentId: "sc-7zc33b-1"
})(["color:", ";font-weight:", ";"], function (props) {
  return colorUsage.message[props.variant];
}, fontWeight.bold);
export { LastSaveSince, SaveIcon };